import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-basic-additional-information-view',
  templateUrl: './basic-additional-information-view.component.html',
  styleUrls: ['./basic-additional-information-view.component.css'],
})
export class BasicAdditionalInformationViewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
